package meineglasfaser.api

import kotlinx.serialization.Serializable

enum class NetworkCategoryType {
    GLASFASER,
    FESTNETZ,
    LTE,
    RICHTFUNK,
    TELEFONIE;
}

@Serializable
data class NetworkCategory(
    val id: String,
    val type: NetworkCategoryType,
    val orderPos: Int,
    val title: String,
    val summary: String,
    val details: String,
)

@Serializable
data class Network(
    val id: String,
    val categoryId: String,
    val orderPos: Int,
    val title: String,
    val summary: String,
    val details: String,
)
